'use client'
import { inter } from '@/config/fonts'
import Link from 'next/link'

interface Props {
  slug: string
  stock: number
  href: string
}

export const StockLabel = ({ slug, stock, href }: Props) => {
  return (
    <>
      <h1 className={`${inter.className} font-bold text-lg`}>
        Stock:
        {stock > 0 ? (
          ' Disponible'
        ) : (
          <>
            {' sin stock -'}{' '}
            <Link
              href={href}
              className={'text-blue-800'}
              target="_blank"
              rel="noopener noreferrer"
            >
              consultar
            </Link>
          </>
        )}
      </h1>
    </>
  )
}
